{
  "REGISTER": {
    "TRY_WOOT": "Nieuw account aanmaken",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "Registreren",
    "TESTIMONIAL_HEADER": "Er is maar één stap nodig om vooruit te komen",
    "TESTIMONIAL_CONTENT": "U bent één stap verwijderd van het communiceren met uw klanten, ze te behouden en nieuwe te vinden.",
    "TERMS_ACCEPT": "Door het aanmaken van een account, gaat u akkoord met onze <a href=\"https://www.chatwoot.com/terms\">T & C</a> en <a href=\"https://www.chatwoot.com/privacy-policy\">Privacy policy</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Registreren met Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Bedrijfsnaam",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "Company name is too short"
    },
    "FULL_NAME": {
      "LABEL": "Volledige naam",
      "PLACEHOLDER": "Voer je volledige naam in, bijvoorbeeld Bruce Wayne",
      "ERROR": "Volledige naam is te kort"
    },
    "EMAIL": {
      "LABEL": "Werk e-mail",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "Wachtwoord",
      "PLACEHOLDER": "Wachtwoord",
      "ERROR": "Wachtwoord is te kort",
      "IS_INVALID_PASSWORD": "Password should contain atleast 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Bevestig wachtwoord",
      "PLACEHOLDER": "Bevestig wachtwoord",
      "ERROR": "Wachtwoorden komen niet overeen."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "Kan geen verbinding maken met Woot Server, probeer het later opnieuw"
    },
    "SUBMIT": "Account aanmaken",
    "HAVE_AN_ACCOUNT": "Heeft u al een account?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Resend verification email",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
